import { API_REQUEST_TYPES } from "../../enums";
import { queryClient } from "../../query-client";
import { resetApi } from "../../services/axios";
import { setUserInfo, updateUserInfo } from "../../store/modules/auth";
import { API } from "../endpoints";
import { getUserProfile, updateUserProfile } from "../profile";
import * as _ from "lodash";

function setAuthTokens({ token, refreshToken }) {
  localStorage.setItem("token", `Bearer ${token}`);
  localStorage.setItem("refreshToken", `${refreshToken}`);
}

export function userLogin(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.AUTH.LOGIN,
        payload,
        config: {
          validateUser: false,
        },
      })
    );

    if (res.success) {
      setAuthTokens({
        token: res.data.token,
        refreshToken: res.data.refreshToken,
      });

      await dispatch(setUserInfo(res.data));

      await dispatch(getUserDetails(res?.data?.id));

      if (res?.data?.profileId) {
        await dispatch(getUserProfile());
      }
    }

    return res;
  };
}

export function userSignup(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.AUTH.SIGNUP,
        payload,
        config: {
          validateUser: false,
        },
      })
    );

    if (res.success) {
      setAuthTokens({
        token: res.data.token,
        refreshToken: res.data.refreshToken,
      });
      dispatch(setUserInfo(res.data));

      if (res.data?.profileId) {
        await dispatch(getUserProfile());
      }
    }

    return res;
  };
}

export function getUserDetails(id) {
  return async function (dispatch, getState) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.GET,
        url: API.AUTH.GET_USER_DETAILS(id),
        payload: {},
        config: {},
      })
    );

    if (res.success) {
      if (id === getState().auth?.user?.id) {
        dispatch(updateUserInfo(res.data));
      }
    }

    return res;
  };
}

export function updateUserDetails(id, payload, config = {}) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.AUTH.UPDATE_USER_DETAILS(id),
        payload,
        config: {
          successMessage: "User updated successfully",
          ...config,
        },
      })
    );

    if (res.success) {
      dispatch(updateUserInfo(res.data));
    }

    return res;
  };
}

export function userForgotPassword(payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.AUTH.FORGOT_PASSWORD,
        payload,
        config: {
          validateUser: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function userResetPassword(token, payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.AUTH.RESET_PASSWORD(token),
        payload,
        config: {
          validateUser: false,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function userRefreshToken() {
  return async function (dispatch) {
    const payload = {
      refreshToken: localStorage.getItem("refreshToken"),
    };

    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.AUTH.REFRESH_TOKEN,
        payload,
        config: {
          validateUser: false,
          notifyError: true,
        },
      })
    );

    if (res.success) {
      setAuthTokens({
        token: res.data.token,
        refreshToken: res.data.refreshToken,
      });

      await dispatch(setUserInfo(res.data));

      await dispatch(getUserDetails(res?.data?.id));

      if (res?.data?.profileId) {
        await dispatch(getUserProfile());
      }
    } else {
      await dispatch(userLogout());
    }

    return res;
  };
}

export function userChangePassword(id, payload) {
  return async function (dispatch) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.PUT,
        url: API.AUTH.CHANGE_PASSWORD(id),
        payload,
        config: {
          validateUser: true,
        },
      })
    );

    if (res.success) {
    }

    return res;
  };
}

export function userLogout() {
  return async function (dispatch) {
    queryClient.clear();
    dispatch({
      type: "USER_LOGOUT",
    });
  };
}

export function validateTokenAndSignin(token) {
  return async function (dispatch, getState) {
    const res = await dispatch(
      resetApi({
        type: API_REQUEST_TYPES.POST,
        url: API.AUTH.VALIDATE_TOKEN_AND_SIGNIN(token),
        payload: {},
        config: {
          validateUser: false,
          notifyError: true,
        },
      })
    );

    if (res.success) {
      setAuthTokens({
        token: res.data.token,
        refreshToken: res.data.refreshToken,
      });

      await dispatch(setUserInfo(res.data));

      await dispatch(getUserDetails(res?.data?.id));

      if (res?.data?.profileId) {
        await dispatch(getUserProfile());
      }
    }

    return res;
  };
}
